import React from 'react';
import PropTypes from 'prop-types';

const View = ({ type, layer = false, active = false, children }) => {
    const className = `View ${type} ${layer ? 'is-layer' : ''} ${active ? 'is-active' : ''}`
    return (
        <div className={className}>
            {children}
        </div>
    )
}

View.propTypes = {
    type: PropTypes.string.isRequired,
    layer: PropTypes.bool,
    active: PropTypes.bool
}

export default View;


// WEBPACK FOOTER //
// ./components/View.js